// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"707":"35a30fff","839":"4f598eb9"}[chunkId] + ".css";
};